/** Doctor portal API client — connects to doctor-api backend. */
import { fetchAuthSession } from "aws-amplify/auth";
import {
  createAuthHelpers,
  createApiFetch,
  createAuditContextHeadersFn,
} from "@hiya/ui";
import { isStub, signOut } from "../auth/auth-service";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "";

const { handleUnauthorized, getAuthHeaders } = createAuthHelpers({ isStub, signOut, fetchAuthSession });

const getAuditContextHeaders = createAuditContextHeadersFn({
  appVersion: import.meta.env.VITE_APP_VERSION,
  // Locale: i18n not yet in use; auditContext falls back to
  // navigator.language. When a locale provider lands, pass it via the
  // `getLanguage` option here.
});

export const apiFetch = createApiFetch(
  API_BASE,
  getAuthHeaders,
  handleUnauthorized,
  getAuditContextHeaders,
);
